import CryptoJS from "crypto-js"
import * as simpleApi from "request/simple";

/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
	if (!name) return;
	if (typeof content !== 'string') {
		content = JSON.stringify(content);
	}
	window.localStorage.setItem(name, content);
}

/**
 * 获取localStorage
 */
export const getStore = name => {
	if (!name) return;
	var value = window.localStorage.getItem(name);
    if (value !== null) {
        try {
            value = JSON.parse(value);
        } catch (e) {
            value = value;
        }
    }
    return value;
}

/**
 * 删除localStorage
 */
export const removeStore = name => {
	if (!name) return;
	window.localStorage.removeItem(name);
}

/**
 * 让整数自动保留2位小数
 */
// export const returnFloat = value => { 
//     var value=Math.round(parseFloat(value)*100)/100; 
//     var xsd=value.toString().split("."); 
//     if(xsd.length==1){ 
//         value=value.toString()+".00"; 
//         return value;   
//     } 
//     if(xsd.length>1){ 
//         if(xsd[1].length<2){ 
//             value=value.toString()+"0"; 
//         } 
//         return value; 
//     } 
// } 
/**
 * @param {date} 标准时间格式:Fri Nov 17 2017 09:26:23 GMT+0800 (中国标准时间)
 * @param {type} 类型
 *   type == 1 ---> "yyyy-mm-dd hh:MM:ss.fff"
 *   type == 2 ---> "yyyymmddhhMMss"
 *   type == '' ---> "yyyy-mm-dd hh:MM:ss"
 *   type == 3 ---> "yyyy-mm-dd"
 *   type == 4 ---> "yyyy-mm-dd hh:MM"
 */
export const formatDate = (date, type) =>{
    var year = date.getFullYear();//年
    var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;//月
    var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();//日
    var hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();//时
    var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();//分
    var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();//秒
    var milliseconds = date.getMilliseconds() < 10 ? "0" + date.getMilliseconds() : date.getMilliseconds() //毫秒
    if (type == 1) {
        return year + "-" + month + "-" + day + " " + hour + ":" + minutes + ":" + seconds + "." + milliseconds;
    } else if (type == 2) {
        return year+""+month+""+day+""+hour+""+minutes+""+seconds;
    } else if (type == 3){
        return year + "-" + month + "-" + day;
    } else if (type == 4) {
        return year + "-" + month + "-" + day + " " + hour + ":" + minutes;
    } else {
        return year + "-" + month + "-" + day + " " + hour + ":" + minutes + ":" + seconds;
    }
}
/**
 * 时间转换：20150101010101 --> '2015-01-01 01:01:01'
 */
export const parseToDate = (timeValue) => {
    var result = "";
    var year = timeValue.substr(0, 4);
    var month = timeValue.substr(4, 2);
    var date = timeValue.substr(6, 2);
    var hour = timeValue.substr(8, 2);
    var minute = timeValue.substr(10, 2);
    var second = timeValue.substr(12, 2);
    result = year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
    return result;
}
/**
 * 判断空值
 */
export const isEmpty = (keys) => {
    if (typeof keys === "string") {
        keys = keys.replace(/\"|&nbsp;|\\/g, '').replace(/(^\s*)|(\s*$)/g, "");
        if (keys == "" || keys == null || keys == "null" || keys === "undefined" ) {
            return true;
        } else {
            return false;
        }
    } else if (typeof keys === "undefined") {  // 未定义
        return true;
    } else if (typeof keys === "number") {
        return false;
    }else if(typeof keys === "boolean"){
        return false;
    }else if(typeof keys == "object"){
        if(JSON.stringify(keys )=="{}"){
            return true;
        }else if(keys == null){ // null
            return true;
        }else{
            return false;
        }
    }

    if(keys instanceof Array && keys.length == 0){// 数组
        return true;
    }

}

/**
 * 返回两位的小数的字符串
 */
export const toFixedNum = (num) => {
    const tonum = Number(num).toFixed(2);
    return tonum;
}

export const showMessage = () =>{
    this.$message({
        showClose: true,
        message: '对不起，您暂无此操作权限~',
        type: 'success'
    });
}

/**
 * 读取base64
 */
export const  readFile = file => {
    console.log(file)
    //var file = this.files[0];
    //判断是否是图片类型
    if (!/image\/\w+/.test(file.raw.type)) {
        alert("只能选择图片");
        return false;
    }
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function (e) { 
        var filedata = {
            filename: file.name,
            filebase64: e.target.result
        }
        alert(e.target.result)
    }
}

/**
 * 动态插入css
 */
export const loadStyle = url => {
    const link = document.createElement('link')
    link.type = 'text/css'
    link.rel = 'stylesheet'
    link.href = url
    const head = document.getElementsByTagName('head')[0]
    head.appendChild(link)
  }
  /**
   * 设置浏览器头部标题
   */
  export const setTitle = (title) => {
    title = title ? `${title}` : '小爱Admin'
    window.document.title = title
  }

  export const param2Obj = url => {
    const search = url.split('?')[1]
    if (!search) {
      return {}
    }
    return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
  }

  //是否为正整数
export const isInteger = (s) => {
    var re = /^[0-9]+$/ ;
    return re.test(s)
}   

export const setContentHeight = (that,ele,height) => {
    that.$nextTick(() => {
        ele.style.height =   (document.body.clientHeight - height)+'px'
    })
  }


export const searchText = (s) => {
    return s == ''?null:s
}

export const strLeft = (s, len) => {
    return s == ''?null:s.substr(0, len);
}

export const splitDate = (cellValue) => {
    if(cellValue != null && cellValue.length > 7){
        return cellValue.substring(0, 4) + "-" + cellValue.substring(4,6) + "-" + cellValue.substring(6,8);
    }
    return cellValue;
}

export const splitTime = (cellValue) => {
    if(cellValue != null && cellValue.length > 13){
        return cellValue.substring(8, 10) + ":" + cellValue.substring(10,12) + ":" + cellValue.substring(12,14);
    }
    return cellValue;
}

// export const urlAddTimestamp = async(url) => {
export const urlAddTimestamp = (url) => {
    // debugger
    let getTimestamp=new Date().getTime();
    if(url.indexOf("?")>-1){
        url=url+"&timestamp="+getTimestamp
    }else{
        url=url+"?timestamp="+getTimestamp
    }
    return url;
}

export const acadyearTermList = () => {
    let acadyearTermList = [];
    let now = new Date();
    let year = parseInt(now.getFullYear());
    acadyearTermList.push((year) + '-' + (year+1) + '第二学期');
    acadyearTermList.push((year) + '-' + (year+1) + '第一学期');
    acadyearTermList.push((year-1) + '-' + year + '第二学期');
    acadyearTermList.push((year-1) + '-' + year + '第一学期');
    acadyearTermList.push((year-2) + '-' + (year-1) + '第二学期');
    acadyearTermList.push((year-2) + '-' + (year-1) + '第一学期');
    acadyearTermList.push((year-3) + '-' + (year-2) + '第二学期');
    acadyearTermList.push((year-3) + '-' + (year-2) + '第一学期');

    return acadyearTermList;
}

export const decryptXueZhong = (encryptData) => {
    let key = CryptoJS.enc.Utf8.parse('IOzz0YCbsM8ijmBV')
    let iv = CryptoJS.enc.Utf8.parse('ZZWBKJ_ZHIHUAWEI');
    let decrypt = CryptoJS.AES.decrypt(encryptData, key, {
        iv: iv,
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
    })
    return CryptoJS.enc.Utf8.stringify(decrypt).toString()
}

export const suoXiao = (scale) => {
    if(scale > 1){
        let s = scale
        while (true){
            s = s / 10
            if(s < 1) return s
        }
    }
    return scale
}

export const examStatus = (cellValue) => {
    if(cellValue == '00'){
        return '未预处理';
    }else if(cellValue == '01'){
        return '待校对';
    }else if(cellValue == 'SB'){
        return '识别中';
    }else if(cellValue == 'UN'){
        return '未知异常';
    }else if(cellValue == 'YA'){
        return '答题卡缺失';
    }else if(cellValue == 'Y1'){
        return '学号异常';
    }else if(cellValue == 'Y3'){
        return '定位异常';
    }else if(cellValue == 'Y4'){
        return '学号异常';
    }else if(cellValue == 'C1'){
        return '学号异常处理中';
    }else if(cellValue == 'SY'){
        return '第一页异常';
    }else if(cellValue == 'Y5'){
        return '定位点缺失';
    }else if(cellValue == 'Y6'){
        return '切图异常';
    }else if(cellValue == 'Y7'){
        return '试卷类型异常';
    }else if(cellValue == 'Y9'){
        return '学号重复';
    }else if(cellValue == 'TT'){
        return '填涂异常';
    }else if(cellValue == 'F1'){
        return '找不到第一页';
    }else if(cellValue == 'RK'){
        return '入库中';
    }else if(cellValue == 'RKEnd'){
        return '已入库';
    }else if(cellValue == 'ZC'){
        return '正常';
    }
    return cellValue == ''?null:cellValue
}


export const getDomain = () => {
    // 获取当前URL
    let urlString = process.env.NODE_ENV === 'production' ? window.g.PROD_HOST : window.g.DEV_HOST;

    // 创建一个URL对象
    const url = new URL(urlString);

    // 获取域名和端口号
    const domain = url.hostname;
    const port = url.port;

    // 如果端口号存在，则返回域名和端口号，否则只返回域名
    return `${url.protocol}//${domain}${port ? ':' + port : ''}`;
};

// 修改访问路径中的特殊字符（+，-，*等）
// export const  changeSpecialCode = async (name, fullName) => {
export const  changeSpecialCode =  (name, fullName) => {
    let type = name.split('/')[0] == '手工补录'
    // 请求路径抬头切换
    let title_before = fullName.split('/')[2]
    let title_after = window.g.OSS_HOST.split('/')[2]
    if(type) {
        let url = fullName.replace(title_before,title_after)
        return url
    }
    let before = name.split('/')[2]
    let after =  before.replace(/[ +#?%&="']/g, match => 
        ({
          ' ': '%20',
          '+': '%2B',
          '#': '%23',
          '?': '%3F',
          '%': '%25',
          '&': '%26',
          '=': '%3D',
          '"': '%22',
          "'": '%27'
        }[match])
      );
    //   let a = fullName.replace(before,after)
      // 替换抬头
      let url = fullName.replace(title_before,title_after)
      // 替换特殊字符
      let a = url.replace(before, after)
      // 添加签名 根据桶的相对路径
    //   let signUrl  = await getSignUrl(a)
      return a

};

// 添加用户有效期限签名
export const getSignUrl = async (url) => {
    let param = { controllerName: 'public/', methodName: 'getSignUrl', param: {url: url}};
    return simpleApi.post(param).then(({result: {code, data}}) =>  {
        return data
    })
    
}

// 获取当前学年学期(包含寒暑假)
export const getSemesterWithHolidays =  (date = new Date())  =>{
    let nowSemester = ""
    let month = date.getMonth() + 1; // 1-12月
    let year = parseInt(date.getFullYear());

    // 第一学期：9月-次年2月(包含寒假)
    if (month >= 9 || month <= 2) {
        nowSemester =  year + '-' + (year+1) +  '第一学期';
    } 

    // 第二学期：3月-8月(包含暑假)  学年：上一年-当年
    else if (month >= 3 && month <= 8) {
        nowSemester = (year - 1) + '-' + year + '第二学期';
    }

    console.log("当前学期=======》", nowSemester)

    return nowSemester
}



// 清理 HTML 标签 + 零宽字符 + 多余空格（支持中英文）
export const cleanHtmlToText = (html) => {
    if (!html) return ''

    let text = html
  
    // 1. 先干掉所有 HTML 标签 <xxx>
    text = text.replace(/<[^>]+>/g, '')
  
    // 2. 干掉所有 HTML 实体：&ensp; &nbsp; &#8203; &amp; 等
    text = text.replace(/&[#a-zA-Z0-9]+;/g, '')
  
    // 3. 干掉 Unicode 零宽字符（双重保险）
    text = text.replace(/[\u200b\u200c\u200d\ufeff]/g, '')
  
    // 4. 多个空格 → 1个空格，首尾去空格
    text = text.replace(/\s+/g, ' ').trim()
  
    return text
  }


  // 判断当前客观题的汇算比例版本（比例换算，等分换算）
export const getPercentType = (uudt) => {
    let percentType = false
    let time = new Date(uudt)
    // 判断P2-P15的版本规则
    let isRules = new Date('2026-10-25T00:00:00.000+08:00');
    // 如果答题卡的更新时间晚于规定的时间 那启动等分的percent
    if(time > isRules) percentType = true
    return percentType





}

// 返回指定比例版本
export const getPercent = (type) => {

    // 比例换算版本
    let percent = {
        "P2": [[0.4341085271317829416663750, 0.748062015503875991667], [0.748062015503875991667, 1]], 
        // "P2": [[0.2, 0.6], [0.6, 1]], 
        // "PD2": [[0.37184693, 0.689799434], [0.689799434, 1]],
        "PD2": [[0.433821418333, 0.73459296629632963], [0.70141708708336667, 1]],
        "P3": [[0.353982300884955750000, 0.5693215339233038333333333],
            [0.5693215339233038333333333, 0.7846607669616519166666666], 
            [0.7846607669616519166666666, 1]],
        // 0.8
        // "P4": [[0.2857142857142857000000, 0.4595238095238095133333333], [0.4595238095238095133333333,0.6333333333333333266666666], [0.6333333333333333266666666, 0.8071428571428571399999999], [0.8071428571428571399999999, 1]],
        // 0.75
        "P4": [[0.2857142857142857000000, 0.46428571428571427500000000],
        [0.46428571428571427500000000,0.64285714285714285000000000], 
        [0.64285714285714285000000000, 0.82142857142857142500000000], 
        [0.82142857142857142500000000, 1]],
        
        "P5": [[0.2395209580838323500000, 0.39161676646706588000000000], 
        [0.39161676646706588000000000, 0.54371257485029941000000000],
            [0.54371257485029941000000000, 0.69580838323353294000000000],
            [0.69580838323353294000000000, 0.84790419161676647000000000], 
            [0.84790419161676647000000000 , 1]],
            
        "P6": [[0.2061855670103092750000, 0.33848797250859106250000000], 
        [0.33848797250859106250000000, 0.47079037800687285000000000],
            [0.47079037800687285000000000, 0.60309278350515463750000000], 
            [0.60309278350515463750000000, 0.73539518900343642500000000], 
            [0.73539518900343642500000000,0.86769759450171821250000000], 
            [0.86769759450171821250000000, 1]],


        "P7": [[0.1809954751131221875000, 0.29799612152553330357142857],
            [0.29799612152553330357142857, 0.41499676793794441964285714],
            [0.41499676793794441964285714,0.53199741435035553571428571],
            [0.53199741435035553571428571, 0.64899806076276665178571428],
            [0.64899806076276665178571428,  0.76599870717517776785714285],
                [0.76599870717517776785714285,  0.88299935358758888392857142],
                [0.88299935358758888392857142, 1]],


        "P8": [[0.1612903225806451625000, 0.26612903225806451718750000],
            [0.26612903225806451718750000, 0.37096774193548387187500000],
            [0.37096774193548387187500000,  0.47580645161290322656250000],
            [0.47580645161290322656250000,  0.58064516129032258125000000],
            [0.58064516129032258125000000,  0.68548387096774193593750000],
                [0.68548387096774193593750000,  0.79032258064516129062500000],
                [0.79032258064516129062500000, 0.89516129032258064531250000],
                [0.89516129032258064531250000, 1]],


                
        "P9": [[0.1454545454545454500000,0.24040404040404040000000000],
            [0.24040404040404040000000000 ,  0.33535353535353535000000000],
            [0.33535353535353535000000000, 0.43030303030303030000000000],
            [0.43030303030303030000000000,  0.52525252525252525000000000],
            [0.52525252525252525000000000,  0.62020202020202020000000000],
                [0.62020202020202020000000000, 0.71515151515151515000000000],
                [0.71515151515151515000000000,  0.81010101010101010000000000],
                [0.81010101010101010000000000,  0.90505050505050505000000000],
                [0.90505050505050505000000000, 1]],


        "P10": [[0.1324503311258278125000,  0.21920529801324503125000000],
            [0.21920529801324503125000000, 0.30596026490066225000000000], //B
            [0.30596026490066225000000000, 0.39271523178807946875000000],
            [0.39271523178807946875000000,  0.47947019867549668750000000], //D
            [0.47947019867549668750000000, 0.56622516556291390625000000],
            [0.56622516556291390625000000,  0.65298013245033112500000000], //F
            [0.65298013245033112500000000,  0.73973509933774834375000000],

            [0.73973509933774834375000000,  0.843841059602649006250000000], //H
            [0.843841059602649006250000000,  0.91324503311258278125000000],
            [0.91324503311258278125000000, 1]],

        //   [0.73973509933774834375000000,  0.82649006622516556250000000], //H
        //   [0.82649006622516556250000000,  0.91324503311258278125000000],
        //   [0.91324503311258278125000000, 1]],



        "P11": [[0.121580547112462000000, 0.2014368610113290909090909], 
        [0.2014368610113290909090909, 0.2812931749101961818181818],
        [0.2812931749101961818181818, 0.3611494888090632727272727], 
        [0.3611494888090632727272727,0.4410058027079303636363636], 
        [0.4410058027079303636363636, 0.5208621166067974545454545], 
        [0.5208621166067974545454545, 0.6007184305056645454545454 ],
        [0.6007184305056645454545454,  0.6805747444045316363636363], 

        [0.6805747444045316363636363, 0.77640232108317214545454538], 
        [0.77640232108317214545454538,  0.84028737220226581818181810], 
        [0.84028737220226581818181810,  0.916150870406189554545454455], 
        [0.916150870406189554545454455, 1]],

        // [0.6805747444045316363636363, 0.7604310583033987272727272], 
        // [0.7604310583033987272727272,  0.8402873722022658181818181], 
        // [0.8402873722022658181818181,  0.9201436861011329090909090], 
        // [0.9201436861011329090909090, 1]],



        "P12": [[0.112359550561797750000, 0.1863295880149812708333333],  //A
        [0.1863295880149812708333333, 0.2602996254681647916666666], //B
        [0.2602996254681647916666666,  0.3342696629213483124999999],
        [0.3342696629213483124999999,  0.4082397003745318333333332], //D
        [0.4082397003745318333333332,  0.4822097378277153541666665],
        [0.4822097378277153541666665, 0.5561797752808988749999998], //F
        [0.5561797752808988749999998,  0.6301498127340823958333331],

        [0.6301498127340823958333331,  0.71891385767790262083333306], //H
        [0.71891385767790262083333306,  0.77808988764044943749999970],
        [0.77808988764044943749999970,  0.848361423220973782291666335], //J
        [0.848361423220973782291666335,  0.922331460674157303124999635],
        [0.922331460674157303124999635, 1]],

        // [0.6301498127340823958333331,  0.7041198501872659166666664], //H
        // [0.7041198501872659166666664,  0.7780898876404494374999997],
        // [0.7780898876404494374999997,  0.8520599250936329583333330], //J
        // [0.8520599250936329583333330,  0.9260299625468164791666663],
        // [0.9260299625468164791666663, 1]],


        "P13": [[0.104438642297650125000, 0.1733279775055231923076923],  //A
        [0.1733279775055231923076923,  0.2422173127133962596153846], //B
        [0.2422173127133962596153846,  0.3111066479212693269230769],
        [0.3111066479212693269230769, 0.3799959831291423942307692], //D
        [0.3799959831291423942307692,  0.4488853183370154615384615],
        [0.4488853183370154615384615,  0.5177746535448885288461538], //F
        [0.5177746535448885288461538,  0.5866639887527615961538461],

        [0.5866639887527615961538461, 0.66933119100220927692307686], //H
        [0.66933119100220927692307686,  0.72444265916850773076923070],
        [0.72444265916850773076923070,  0.789887527615987144711538385], //J
        [0.789887527615987144711538385, 0.858776862823860212019230685],
        [0.858776862823860212019230685,   0.927666198031733279326922985],
        [0.927666198031733279326922985, 1]],

        // [0.5866639887527615961538461, 0.6555533239606346634615384], //H
        // [0.6555533239606346634615384,  0.7244426591685077307692307],
        // [0.7244426591685077307692307,  0.7933319943763807980769230], //J
        // [0.7933319943763807980769230, 0.8622213295842538653846153],
        // [0.8622213295842538653846153,  0.9311106647921269326923076],
        // [0.9311106647921269326923076, 1]],



        "P14": [[0.0975609756097561000000,  0.16202090592334495000000000],  //A
        [0.16202090592334495000000000, 0.22648083623693380000000000 ], //B
        [0.22648083623693380000000000,  0.29094076655052265000000000],
        [0.29094076655052265000000000,  0.35540069686411150000000000], //D
        [0.35540069686411150000000000, 0.41986062717770035000000000 ],
        [0.41986062717770035000000000,  0.48432055749128920000000000], //F
        [0.48432055749128920000000000,  0.54878048780487805000000000],
        

        [0.54878048780487805000000000,  0.626132404181184670000000000], //H
        [0.626132404181184670000000000,  0.67770034843205575000000000],
        [0.67770034843205575000000000,  0.7389372822299651575000000000], //J
        [0.7389372822299651575000000000,  0.8033972125435540075000000000],
        [0.8033972125435540075000000000,   0.8678571428571428575000000000],
        [0.8678571428571428575000000000,  0.9323170731707317075000000000],
        [0.9323170731707317075000000000, 1]],

        // [0.54878048780487805000000000,  0.61324041811846690000000000], //H
        // [0.61324041811846690000000000,  0.67770034843205575000000000],
        // [0.67770034843205575000000000,  0.74216027874564460000000000], //J
        // [0.74216027874564460000000000,  0.80662020905923345000000000],
        // [0.80662020905923345000000000,  0.87108013937282230000000000],
        // [0.87108013937282230000000000,  0.93554006968641115000000000],
        // [0.93554006968641115000000000, 1]],


        "P15": [[0.0915331807780320375000, 0.15209763539282990166666667],  //A
        [0.15209763539282990166666667,  0.21266209000762776583333334], //B
        [0.21266209000762776583333334,  0.27322654462242563000000001],
        [0.27322654462242563000000001,  0.33379099923722349416666668], //D
        [0.33379099923722349416666668,  0.39435545385202135833333335],
        [0.39435545385202135833333335,  0.45491990846681922250000002], //F
        [0.45491990846681922250000002, 0.51548436308161708666666669 ],
        
        [0.51548436308161708666666669,  0.588161708619374523666666694], //H
        [0.588161708619374523666666694,  0.63661327231121281500000003],
        [0.63661327231121281500000003, 0.691121281464530892750000033 ], //J
        [0.691121281464530892750000033, 0.751685736079328756916666703 ],
        [0.751685736079328756916666703, 0.812250190694126621083333373],
        [0.812250190694126621083333373, 0.872814645308924485250000043],
        [0.872814645308924485250000043, 0.933379099923722349416666713],
        [0.933379099923722349416666713, 1]],

        // [0.51548436308161708666666669,  0.57604881769641495083333336], //H
        // [0.57604881769641495083333336,  0.63661327231121281500000003],
        // [0.63661327231121281500000003, 0.69717772692601067916666670 ], //J
        // [0.69717772692601067916666670,  0.75774218154080854333333337],
        // [0.75774218154080854333333337,  0.81830663615560640750000004],
        // [0.81830663615560640750000004, 0.87887109077040427166666671],
        // [0.87887109077040427166666671, 0.93943554538520213583333338 ],
        // [0.93943554538520213583333338, 1]],
        
    }

    // 等分距离版本
    let  percent_avg = {
            "P2": [[0.4341085271317829416663750, 0.748062015503875991667], [0.748062015503875991667, 1]], 
            "PD2": [[0.433821418333, 0.73459296629632963], [0.70141708708336667, 1]],

            "P3": [[0.353982300884955750000, 0.5693215339233038333333333],
                [0.5693215339233038333333333, 0.7846607669616519166666666], 
                [0.7846607669616519166666666, 1]],

            "P4": [[0.2857142857142857000000, 0.46428571428571427500000000],
            [0.46428571428571427500000000,0.64285714285714285000000000], 
            [0.64285714285714285000000000, 0.82142857142857142500000000], 
            [0.82142857142857142500000000, 1]],
            
            "P5": [[0.2395209580838323500000, 0.39161676646706588000000000], 
            [0.39161676646706588000000000, 0.54371257485029941000000000],
                [0.54371257485029941000000000, 0.69580838323353294000000000],
                [0.69580838323353294000000000, 0.84790419161676647000000000], 
                [0.84790419161676647000000000 , 1]],
                
            "P6": [[0.2061855670103092750000, 0.33848797250859106250000000], 
            [0.33848797250859106250000000, 0.47079037800687285000000000],
                [0.47079037800687285000000000, 0.60309278350515463750000000], 
                [0.60309278350515463750000000, 0.73539518900343642500000000], 
                [0.73539518900343642500000000,0.86769759450171821250000000], 
                [0.86769759450171821250000000, 1]],


            "P7": [[0.1809954751131221875000, 0.29799612152553330357142857],
                [0.29799612152553330357142857, 0.41499676793794441964285714],
                [0.41499676793794441964285714,0.53199741435035553571428571],
                [0.53199741435035553571428571, 0.64899806076276665178571428],
                [0.64899806076276665178571428,  0.76599870717517776785714285],
                    [0.76599870717517776785714285,  0.88299935358758888392857142],
                    [0.88299935358758888392857142, 1]],


            "P8": [[0.1612903225806451625000, 0.26612903225806451718750000],
                [0.26612903225806451718750000, 0.37096774193548387187500000],
                [0.37096774193548387187500000,  0.47580645161290322656250000],
                [0.47580645161290322656250000,  0.58064516129032258125000000],
                [0.58064516129032258125000000,  0.68548387096774193593750000],
                    [0.68548387096774193593750000,  0.79032258064516129062500000],
                    [0.79032258064516129062500000, 0.89516129032258064531250000],
                    [0.89516129032258064531250000, 1]],


                    
            "P9": [[0.1454545454545454500000,0.24040404040404040000000000],
                [0.24040404040404040000000000 ,  0.33535353535353535000000000],
                [0.33535353535353535000000000, 0.43030303030303030000000000],
                [0.43030303030303030000000000,  0.52525252525252525000000000],
                [0.52525252525252525000000000,  0.62020202020202020000000000],
                    [0.62020202020202020000000000, 0.71515151515151515000000000],
                    [0.71515151515151515000000000,  0.81010101010101010000000000],
                    [0.81010101010101010000000000,  0.90505050505050505000000000],
                    [0.90505050505050505000000000, 1]],


            "P10": [[0.1324503311258278125000,  0.21920529801324503125000000],
                [0.21920529801324503125000000, 0.30596026490066225000000000], //B
                [0.30596026490066225000000000, 0.39271523178807946875000000],
                [0.39271523178807946875000000,  0.47947019867549668750000000], //D
                [0.47947019867549668750000000, 0.56622516556291390625000000],
                [0.56622516556291390625000000,  0.65298013245033112500000000], //F
                [0.65298013245033112500000000,  0.73973509933774834375000000],

                [0.73973509933774834375000000,  0.82649006622516556250000000], //H
                [0.82649006622516556250000000,  0.91324503311258278125000000],
                [0.91324503311258278125000000, 1]],



            "P11": [[0.121580547112462000000, 0.2014368610113290909090909], 
            [0.2014368610113290909090909, 0.2812931749101961818181818],
            [0.2812931749101961818181818, 0.3611494888090632727272727], 
            [0.3611494888090632727272727,0.4410058027079303636363636], 
            [0.4410058027079303636363636, 0.5208621166067974545454545], 
            [0.5208621166067974545454545, 0.6007184305056645454545454 ],
            [0.6007184305056645454545454,  0.6805747444045316363636363], 

            [0.6805747444045316363636363, 0.7604310583033987272727272], 
            [0.7604310583033987272727272,  0.8402873722022658181818181], 
            [0.8402873722022658181818181,  0.9201436861011329090909090], 
            [0.9201436861011329090909090, 1]],



            "P12": [[0.112359550561797750000, 0.1863295880149812708333333],  //A
            [0.1863295880149812708333333, 0.2602996254681647916666666], //B
            [0.2602996254681647916666666,  0.3342696629213483124999999],
            [0.3342696629213483124999999,  0.4082397003745318333333332], //D
            [0.4082397003745318333333332,  0.4822097378277153541666665],
            [0.4822097378277153541666665, 0.5561797752808988749999998], //F
            [0.5561797752808988749999998,  0.6301498127340823958333331],

            [0.6301498127340823958333331,  0.7041198501872659166666664], //H
            [0.7041198501872659166666664,  0.7780898876404494374999997],
            [0.7780898876404494374999997,  0.8520599250936329583333330], //J
            [0.8520599250936329583333330,  0.9260299625468164791666663],
            [0.9260299625468164791666663, 1]],


            "P13": [[0.104438642297650125000, 0.1733279775055231923076923],  //A
            [0.1733279775055231923076923,  0.2422173127133962596153846], //B
            [0.2422173127133962596153846,  0.3111066479212693269230769],
            [0.3111066479212693269230769, 0.3799959831291423942307692], //D
            [0.3799959831291423942307692,  0.4488853183370154615384615],
            [0.4488853183370154615384615,  0.5177746535448885288461538], //F
            [0.5177746535448885288461538,  0.5866639887527615961538461],


            [0.5866639887527615961538461, 0.6555533239606346634615384], //H
            [0.6555533239606346634615384,  0.7244426591685077307692307],
            [0.7244426591685077307692307,  0.7933319943763807980769230], //J
            [0.7933319943763807980769230, 0.8622213295842538653846153],
            [0.8622213295842538653846153,  0.9311106647921269326923076],
            [0.9311106647921269326923076, 1]],



            "P14": [[0.0975609756097561000000,  0.16202090592334495000000000],  //A
            [0.16202090592334495000000000, 0.22648083623693380000000000 ], //B
            [0.22648083623693380000000000,  0.29094076655052265000000000],
            [0.29094076655052265000000000,  0.35540069686411150000000000], //D
            [0.35540069686411150000000000, 0.41986062717770035000000000 ],
            [0.41986062717770035000000000,  0.48432055749128920000000000], //F
            [0.48432055749128920000000000,  0.54878048780487805000000000],

            [0.54878048780487805000000000,  0.61324041811846690000000000], //H
            [0.61324041811846690000000000,  0.67770034843205575000000000],
            [0.67770034843205575000000000,  0.74216027874564460000000000], //J
            [0.74216027874564460000000000,  0.80662020905923345000000000],
            [0.80662020905923345000000000,  0.87108013937282230000000000],
            [0.87108013937282230000000000,  0.93554006968641115000000000],
            [0.93554006968641115000000000, 1]],


            "P15": [[0.0915331807780320375000, 0.15209763539282990166666667],  //A
            [0.15209763539282990166666667,  0.21266209000762776583333334], //B
            [0.21266209000762776583333334,  0.27322654462242563000000001],
            [0.27322654462242563000000001,  0.33379099923722349416666668], //D
            [0.33379099923722349416666668,  0.39435545385202135833333335],
            [0.39435545385202135833333335,  0.45491990846681922250000002], //F
            [0.45491990846681922250000002, 0.51548436308161708666666669 ],

            // 等分
            [0.51548436308161708666666669,  0.57604881769641495083333336], //H
            [0.57604881769641495083333336,  0.63661327231121281500000003],
            [0.63661327231121281500000003, 0.69717772692601067916666670 ], //J
            [0.69717772692601067916666670,  0.75774218154080854333333337],
            [0.75774218154080854333333337,  0.81830663615560640750000004],
            [0.81830663615560640750000004, 0.87887109077040427166666671],
            [0.87887109077040427166666671, 0.93943554538520213583333338 ],
            [0.93943554538520213583333338, 1]],

            
    }

    // 为真情况下 或者未传参情况下 都默认是等分距离版本
    if(type || type == undefined ) return percent_avg

    return percent
}